export default __webpack_public_path__ + "static/media/bg-learning.65ee640e.jpg";